<template>
	<div
		class="saved-info-item"
		:class="{ 'saved-info-item--preview' : isPreview }"
	>
		<div
			v-if="!isPreview"
			class="saved-info-item__reordering"
		>
			<button
				v-if="index !== (total - 1)"
				@click="moveContent(content.id, false)"
				type="button"
				class="btn--no-style saved-info-item__reordering-button"
			>
				<div class="saved-info-item__reordering-button-inner">
					<svg svg-inline="" focusable="false" role="presentation" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10V2h6v8h5l-8 8-8-8h5z"/></svg>
					<span>Move down</span>
				</div>
			</button>

			<button
				v-if="index !== 0"
				@click="moveContent(content.id, true)"
				type="button"
				class="btn--no-style saved-info-item__reordering-button"
			>
				<div class="saved-info-item__reordering-button-inner">
					<svg svg-inline="" focusable="false" role="presentation" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" style="margin-top:-2px"><path d="M7 10v8h6v-8h5l-8-8-8 8h5z"/></svg>
					<span>Move up</span>
				</div>
			</button>
		</div>
		<div class="saved-info-item__header">
			<button
				@click="showContent = !showContent"
				type="button"
				class="btn--no-style saved-info-item__heading"
			>
				{{ content.title }}
			</button>
			<button
				v-if="isPreview"
				@click="showContent = !showContent"
				type="button"
				class="btn--no-style btn--remove saved-info-item__button"
			>
				<template v-if="showContent">
					<svg svg-inline="" focusable="false" role="presentation" width="34" height="22" xmlns="http://www.w3.org/2000/svg"><path d="M7.295 16.969c-4.252-2.51-6.222-5.957-6.222-5.957s4.871-8.525 15.832-8.525c1.589 0 3.05.179 4.386.485L18 6.264a4.871 4.871 0 0 0-5.842 5.842L7.294 16.97h0zm5.224 2.082c1.337.307 2.797.486 4.386.486 10.96 0 15.832-8.525 15.832-8.525s-1.97-3.447-6.221-5.957l-4.863 4.862a4.871 4.871 0 0 1-5.842 5.842l-3.292 3.292h0zm8.04-8.04c0 .936-.357 1.87-1.07 2.584a3.642 3.642 0 0 1-2.584 1.07l3.654-3.653h0zm-3.654-3.653c-.935 0-1.87.357-2.583 1.07a3.642 3.642 0 0 0-1.07 2.584l3.653-3.654h0zM26.648.051L5.944 20.755l1.218 1.217L27.866 1.27 26.648.051h0z" stroke="null" fill="#E76402"/></svg>
					<div>Show less</div>
				</template>
				<template v-else>
					<svg svg-inline="" class="eye" focusable="false" role="presentation" viewBox="0 0 53 27" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M.263 13.503v-.006H0C8.159 4.499 17.087 0 26.784 0 36.48 0 45.219 4.499 53 13.497h-.222v.006H53C45.219 22.501 36.48 27 26.784 27 17.087 27 8.159 22.501 0 13.503h.263z" fill="#ff7f1e"/><path d="M20.166 12.477a4.29 4.29 0 1 0 5.311-5.311 7 7 0 1 1-5.311 5.311z" fill="#691e25"/></svg>
					<div>Show more</div>
				</template>
			</button>
			<button
				v-if="!isPreview"
				@click="removeSave([content.id])"
				type="button"
				class="btn--no-style btn--remove saved-info-item__button"
			>
				<div class="btn-remove-icon">
					<svg svg-inline="" focusable="false" role="presentation" width="512" height="512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M417.4 224H94.6C77.7 224 64 238.3 64 256s13.7 32 30.6 32h322.8c16.9 0 30.6-14.3 30.6-32s-13.7-32-30.6-32z" fill="#FFF"/></svg>
				</div>
				<div>Remove</div>
			</button>
		</div>

		<div
			class="saved-info-item__content"
			:class="{ 'fade-out-preview' : !showContent }"
		>
			<hr class="hr--small" />

			<div class="introduction">
				{{ content.excerpt }}
			</div>

			<render-area
				v-if="content.content"
				:value="parsedContent"
			/>
		</div>
	</div>
</template>

<script>
// Mixins
import { tooltips } from '@/mixins/tooltips.js';

// Components
import { RenderArea } from 'rd-vue-block-builder';

// Styles
import '@/sass/components/_builder-blocks.scss';

export default {
	mixins: [tooltips],
	props: ['content', 'isPreview', 'removeSave', 'total', 'index'],
	components: {
		RenderArea
	},
	data() {
		return {
			// showContent: this.index === 0 ? true : false,
			showContent: false,
			parsedContent: null
		};
	},
	methods: {
		moveContent(contentID, directionUp) {
			this.$store.commit('contentLoading', true);

			const newPosition = directionUp ? this.content.order - 1 : this.content.order + 1;

			this.$saves
				.moveContent(this.$store.state.save.uid, contentID, newPosition)
				.then(response => {
					this.$eventBus.$emit('getSave');
					this.$store.commit('contentLoading', false);
				})
				.catch(() => {
					this.$store.commit('contentLoading', false);
					alert('Sorry, there was an issue, please try again');
				});
		}
	},
	created() {
		if (this.content) {
			this.parsedContent = this.$builder.parseBlocks(this.content.content);
			this.$nextTick(() => {
				this.tooltips();
			});
		}
	}
};
</script>
